"use strict";
module.exports = function(options) {
  var getState = options.stateHandler.getState;
  function isDetectable(element) {
    var state = getState(element);
    return state && !!state.isDetectable;
  }
  function markAsDetectable(element) {
    getState(element).isDetectable = true;
  }
  function isBusy(element) {
    return !!getState(element).busy;
  }
  function markBusy(element, busy) {
    getState(element).busy = !!busy;
  }
  return {
    isDetectable,
    markAsDetectable,
    isBusy,
    markBusy
  };
};
